<template>
  <div class="page-main profit-page" v-loading="loading">
    <div class="profit-head">
      <div>
        <span class="profit-title">毛利分析</span>
        <span class="profit-sub">
          销售额、成本、毛利都取核算单（已审核）；成本 = 核算单成本价合计
        </span>
      </div>
      <div>
        <el-button size="mini" plain @click="quick(0)">本月</el-button>
        <el-button size="mini" plain @click="quick(1)">本年</el-button>
        <el-button size="mini" plain @click="quick(2)">近 12 个月</el-button>
        <el-button size="mini" type="primary" plain @click="load">刷新</el-button>
      </div>
    </div>

    <div class="profit-filter">
      <span class="filter-label">统计月份</span>
      <el-date-picker
        v-model="monthRange"
        type="monthrange"
        size="mini"
        value-format="yyyy-MM"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        style="width: 240px"
      />
      <el-button size="mini" type="primary" @click="load">查询</el-button>
    </div>

    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-label">销售额</div>
        <div class="kpi-value c-blue">{{ wan(summary.sales) }}</div>
        <div class="kpi-desc">{{ summary.bill_cnt || 0 }} 张核算单</div>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">成本</div>
        <div class="kpi-value">{{ wan(summary.cost) }}</div>
        <div class="kpi-desc">占销售额 {{ percent(summary.cost, summary.sales) }}%</div>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">毛利</div>
        <div class="kpi-value c-green">{{ wan(summary.profit) }}</div>
        <div class="kpi-desc">毛利率 {{ profitRate }}%</div>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">费用 / 税额</div>
        <div class="kpi-value c-orange">{{ wan(summary.fees) }}</div>
        <div class="kpi-desc">税额 {{ wan(summary.tax) }}</div>
      </div>
    </div>

    <div class="profit-tip">
      毛利 = 销售额 - 核算单成本价合计。如果核算单里的成本价没填全，毛利会偏高；
      运费、包装费、其他费用在核算单上单独记（费用 {{ wan(summary.fees) }}），做报价分析时要一起看。
    </div>

    <div class="profit-two-col">
      <div class="profit-block">
        <div class="block-head">
          <span class="block-title">按月份</span>
          <span class="block-tip">单位：万元</span>
        </div>
        <el-table :data="monthly" size="mini" border height="360" :header-cell-style="headStyle" show-summary>
          <el-table-column prop="ym" label="月份" width="100" align="center" />
          <el-table-column prop="bill_cnt" label="单数" width="70" align="center" />
          <el-table-column label="销售额" align="right">
            <template #default="{ row }">{{ wan(row.sales) }}</template>
          </el-table-column>
          <el-table-column label="成本" align="right">
            <template #default="{ row }">{{ wan(row.cost) }}</template>
          </el-table-column>
          <el-table-column label="毛利" align="right">
            <template #default="{ row }">
              <span :class="Number(row.profit) >= 0 ? 'c-green' : 'c-red'">{{ wan(row.profit) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="毛利率" width="90" align="right">
            <template #default="{ row }">{{ percent(row.profit, row.sales) }}%</template>
          </el-table-column>
        </el-table>
      </div>

      <div class="profit-block">
        <div class="block-head">
          <span class="block-title">客户毛利 Top 50</span>
          <span class="block-tip">按毛利从高到低</span>
        </div>
        <el-table :data="customers" size="mini" border height="360" :header-cell-style="headStyle">
          <el-table-column type="index" label="#" width="45" align="center" />
          <el-table-column prop="company_name" label="客户" min-width="180" show-overflow-tooltip />
          <el-table-column prop="bill_cnt" label="单数" width="65" align="center" />
          <el-table-column label="销售额" width="100" align="right">
            <template #default="{ row }">{{ wan(row.sales) }}</template>
          </el-table-column>
          <el-table-column label="毛利" width="100" align="right">
            <template #default="{ row }">
              <span :class="Number(row.profit) >= 0 ? 'c-green' : 'c-red'">{{ wan(row.profit) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="毛利率" width="90" align="right">
            <template #default="{ row }">{{ percent(row.profit, row.sales) }}%</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      monthRange: [],
      summary: {},
      profitRate: 0,
      monthly: [],
      customers: []
    }
  },
  mounted() {
    this.quick(1)
  },
  methods: {
    load() {
      this.loading = true
      let range = this.monthRange || []
      this.$api({
        method: 'post',
        url: '/admin/gcvip/finance/profit',
        data: {
          startDate: range[0] ? range[0] + '-01' : '',
          endDate: range[1] ? this.monthEnd(range[1]) : ''
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.summary = res.data.summary || {}
            this.profitRate = Number(res.data.profitRate || 0).toFixed(2)
            this.monthly = res.data.monthly || []
            this.customers = res.data.customers || []
          } else {
            this.$message.error(res.data.msg || '查询失败')
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 0=本月 1=本年 2=近12个月
    quick(type) {
      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      let from = ''
      let to = ''
      let pad = (n) => (n < 10 ? '0' + n : '' + n)
      if (type === 0) {
        from = year + '-' + pad(month)
        to = from
      } else if (type === 1) {
        from = year + '-01'
        to = year + '-' + pad(month)
      } else {
        let start = new Date(year, month - 12, 1)
        from = start.getFullYear() + '-' + pad(start.getMonth() + 1)
        to = year + '-' + pad(month)
      }
      this.monthRange = [from, to]
      this.load()
    },
    monthEnd(ym) {
      let parts = ym.split('-')
      let y = Number(parts[0])
      let m = Number(parts[1])
      let last = new Date(y, m, 0).getDate()
      return ym + '-' + (last < 10 ? '0' + last : last)
    },
    headStyle() {
      return { background: '#f5f7fa', color: '#606266', padding: '6px 0' }
    },
    wan(value) {
      let num = Number(value || 0)
      if (isNaN(num)) num = 0
      return (num / 10000).toFixed(2)
    },
    percent(part, total) {
      let p = Number(part || 0)
      let t = Number(total || 0)
      if (!t) return '0.00'
      return ((p * 100) / t).toFixed(2)
    }
  }
}
</script>

<style lang="less" scoped>
.profit-page {
  padding: 10px 12px 20px;
  overflow-y: auto;
  height: calc(100vh - 86px);
  box-sizing: border-box;
}
.profit-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  .profit-title {
    font-size: 17px;
    font-weight: 600;
    margin-right: 10px;
  }
  .profit-sub {
    font-size: 12px;
    color: #909399;
  }
}
.profit-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  .filter-label {
    font-size: 12px;
    color: #606266;
  }
}
.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}
.kpi-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px 14px;
  .kpi-label {
    font-size: 13px;
    color: #606266;
  }
  .kpi-value {
    font-size: 24px;
    font-weight: 600;
    margin: 6px 0;
  }
  .kpi-desc {
    font-size: 12px;
    color: #909399;
  }
}
.profit-tip {
  font-size: 12px;
  color: #8a5a20;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  padding: 6px 12px;
  margin-bottom: 10px;
  line-height: 20px;
}
.profit-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.profit-block {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px 12px 12px;
  .block-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 8px;
    .block-title {
      font-size: 14px;
      font-weight: 600;
      border-left: 3px solid #396bf6;
      padding-left: 8px;
    }
    .block-tip {
      font-size: 12px;
      color: #a8abb2;
    }
  }
}
.c-blue {
  color: #396bf6;
}
.c-green {
  color: #46bd87;
}
.c-orange {
  color: #e6a23c;
}
.c-red {
  color: #f56c6c;
}
@media screen and (max-width: 1400px) {
  .kpi-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  .profit-two-col {
    grid-template-columns: 1fr;
  }
}
</style>
